<template>
  <div>
    <vxe-grid
      ref="xTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      size="small"
      resizable
      border
      class="tech-processes-table"
      :height="tableHeight"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:drag>
        <span class="drag-btn">
          <i class="vxe-icon--menu"></i>
        </span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditDialog', {
                  type: 'detail',
                  code: row.techProcessesCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditDialog', {
                  type: 'edit',
                  code: row.techProcessesCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.techProcessesCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import Sortable from 'sortablejs'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: tableColumns(this, this.disabled),
      seqConfig: {
        seqMethod({ rowIndex }) {
          return rowIndex
        },
      },
    }
  },
  created() {
    this.rowDrop()
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = (window.innerHeight - 131) / 4 - 50
    },
    del(techProcessesCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.techProcessesDelApi({ techProcessesCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    rowDrop() {
      this.$nextTick(() => {
        const xTable = this.$refs.xTable
        this.sortable = Sortable.create(
          xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'),
          {
            handle: '.drag-btn',
            onEnd: ({ newIndex, oldIndex }) => {
              if (newIndex == oldIndex) return

              const tableData = [...this.tableData]
              let listProcesses = []
              if (newIndex > oldIndex) {
                for (let i = oldIndex + 1; i <= newIndex; i++) {
                  const sortOrder = tableData[i].sortOrder - 1
                  const techProcessesCode = tableData[i].techProcessesCode
                  listProcesses.push({ sortOrder, techProcessesCode })
                }
              } else {
                for (let i = oldIndex - 1; i >= newIndex; i--) {
                  const sortOrder = tableData[i].sortOrder + 1
                  const techProcessesCode = tableData[i].techProcessesCode
                  listProcesses.push({ sortOrder, techProcessesCode })
                }
              }
              listProcesses.push({
                sortOrder: tableData[newIndex].sortOrder,
                techProcessesCode: tableData[oldIndex].techProcessesCode,
              })
              this.updateSort(listProcesses)
            },
          }
        )
      })
    },
    updateSort(listTechProcesses) {
      this.$api
        .techProcessesUpdateSortApi({ listTechProcesses })
        .then((res) => {
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_update_ok') || '修改成功！',
              type: 'success',
            })
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.tech-processes-table .drag-btn {
  cursor: move;
  font-size: 12px;
}
</style>
